export const getNfuEntregadosPorTipoConfig = (data) => {
  if (!data) return {};

   
  let dataCopy = [...data];

  let pltItem = dataCopy.find((item) => item.codigo === "PLT");
  let plt2Item = dataCopy.find((item) => item.codigo === "PLT 2");

  if (pltItem && plt2Item) {
    pltItem.cantidad_recolectada += plt2Item.cantidad_recolectada;
     
    dataCopy = dataCopy.filter((item) => item.codigo !== "PLT 2");
  }
  let total = dataCopy.reduce((sum, item) => sum + item.cantidad_recolectada, 0).toLocaleString();

  return {
    title: {
      text: "Nfu Entregados Por Tipo",
      subtext: `{total|TOTAL NFU ENTREGADOS: }{big|${total}}`,
      right: "center",
      padding: [20, 10, 10, 10],
      textStyle: { fontSize: Math.max(window.innerWidth * 0.02, 16) },
      subtextStyle: { rich: { total: { fontSize: 10 }, big: { fontSize: 18 } } },
    },
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        let totalSum = dataCopy.reduce((sum, item) => sum + item.cantidad_recolectada, 0);
        let porcentaje = ((params.value / totalSum) * 100).toFixed(1);
        return params.value > 0 ? `${params.name}<br/><b style='font-size: 11px;'>${porcentaje}%</b>` : params.name;
      },
      textStyle: { fontSize: 9 },
    },
    legend: {
      top: "bottom",
      icon: "circle",
      formatter: (name) => {
        const item = dataCopy.find((item) => item.codigo === name);
        return item ? `${name} {value|(${item.cantidad_recolectada.toLocaleString()})}` : name;
      },
      textStyle: { fontSize: 10, rich: { value: { fontSize: 11, color: "#495057" } } },
      itemGap: 4,
    },
    series: [
      {
        type: "pie",
        radius: ["13%", "50%"],
        center: "50%",
        data: dataCopy.map((item, index) => ({
          value: item.cantidad_recolectada,
          name: item.codigo,
          itemStyle: {
            color: ["#BBCD21", "#AEAEAE", "#39E295", "#caf0f8", "#001219"][index % 5],
            borderRadius: 4,
            borderColor: "#fff",
            borderWidth: 1,
          },
          label: {
            show: item.cantidad_recolectada > 0,
            formatter: (params) => {
              const totalSum = dataCopy.reduce((sum, item) => sum + item.cantidad_recolectada, 0);
              const porcentaje = ((params.value / totalSum) * 100).toFixed(3); 
              return `${porcentaje}%`;
            },
            fontSize: 10,
          },          
          labelLine: {
            show: item.cantidad_recolectada > 0, 
            length: 8,
            length2: 6,
          },
        })),
      },
    ],
  };
};
